import { createContext, useContext, useMemo } from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const AutocompleteDropdownContext = createContext({
  isOpen: false,
  items: []
});
const AutocompleteDropdownProvider = AutocompleteDropdownContext.Provider;
const useAutocompleteDropdown = () => {
  const _a = useContext(AutocompleteDropdownContext), { items, groupBy } = _a, context = __objRest(_a, ["items", "groupBy"]);
  const getGroupedItems = useMemo(() => {
    if (!groupBy) {
      return items;
    }
    const groups = Array.from(new Set(items.map((item) => groupBy(item))));
    const groupedOptions = groups.map((group, groupIndex) => ({
      group,
      index: groupIndex,
      options: items.filter((option) => groupBy(option) === group)
    }));
    return groupedOptions;
  }, [items, groupBy]);
  return __spreadValues({ items: getGroupedItems, isGrouped: !!groupBy }, context);
};

export { AutocompleteDropdownContext, AutocompleteDropdownProvider, useAutocompleteDropdown };
//# sourceMappingURL=AutocompleteContext.es.js.map
